import {billingConstants} from "../_constants";

export function billing(state = { portalConfiguration: null }, action) {
    switch (action.type) {
        case billingConstants.GET_ALL_DOCUMENTS_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
                documents: null,
                portalConfiguration: null,
            };

        case billingConstants.GET_ALL_DOCUMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                documentWrapper: action.result,
                portalConfiguration: action.result ? action.result.portalConfiguration || null : null,
            };

        case billingConstants.GET_ALL_DOCUMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
                portalConfiguration: null,
            };

        case billingConstants.GET_ORDER_INVOICING_CONFIGURATION_REQUEST:
            return {
                ...state,
                subBillingConfigurationLoading: true,
                invoicingConfigurationLoading: true,
                billingConfigurationModalErrorMessage: null,
                orderInvoicingConfiguration: null,
            };

        case billingConstants.GET_ORDER_INVOICING_CONFIGURATION_SUCCESS:
            return {
                ...state,
                subBillingConfigurationLoading: false,
                invoicingConfigurationLoading: false,
                orderInvoicingConfiguration: action.result,
            };

        case billingConstants.GET_ORDER_INVOICING_CONFIGURATION_FAILURE:
            return {
                ...state,
                subBillingConfigurationLoading: false,
                invoicingConfigurationLoading: false,
                billingConfigurationModalErrorMessage: action.errorMessage,
            };

        // INVOICE TEMPLATE
        case billingConstants.GET_INVOICE_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
                invoice: null
            };

        case billingConstants.GET_INVOICE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                invoice: action.invoice
            };

        case billingConstants.GET_INVOICE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        // CREDITNOTE TEMPLATE
        case billingConstants.GET_CREDIT_NOTE_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
                creditNote: null
            };

        case billingConstants.GET_CREDIT_NOTE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                creditNote: action.creditNote
            };

        case billingConstants.GET_CREDIT_NOTE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };
        default:
            return state;
    }
}
